import { connect } from 'react-redux'
import WishlistMenuItem from './WishlistMenuItem'

const mapStateToProps = ({ wishlistv2: { products } }) => ({
  count: products && products.length
})

export default connect(mapStateToProps)(WishlistMenuItem)



// WEBPACK FOOTER //
// ./src/App/Header/UserProfile/UserProfileSubmenu/WishlistMenuItem/WishlistMenuItemContainer.js